import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import { useSelector } from 'react-redux';
import TableComponent from '../antTable/table';
import { filterData } from '../antTable/filter';
import CustomPagination from '../antTable/pagenation';
import { LoadingContainer, LoadingIndicator, LoadingMessage } from '../antTable/loadingStyle';
const columns = [
  {
    title: 'No',
    dataIndex: 'key',
  },
  {
    title: 'Computers',
    dataIndex: 'title',
  },
];

export default function ComputersData() {
  const { objectData, loading } = useSelector((state) => state.getOuComputersData);
  const searchQuery = useSelector((state) => state.search);

  // Initialize state for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  useEffect(() => {
    // Reset pagination when new data arrives
    setCurrentPage(1);
  }, [objectData, searchQuery]);

  if (loading) {
    // Show a loading indicator when data is loading.
    return (
      <LoadingContainer>
        <LoadingIndicator size='large' />
        <LoadingMessage> Loading...</LoadingMessage>
      </LoadingContainer>
    );
  }
  if (!objectData || objectData.length === 0) {
    return (
      <h1>
        <Empty style={{ paddingTop: '40px' }} />
      </h1>
    );
  }

  const filterKeys = ['title'];
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const filteredData = filterData(objectData, searchQuery, filterKeys);
  const dataToShow = filteredData.slice(startIndex, endIndex);
  return (
    <div>
      <TableComponent columns={columns} data={dataToShow} />
      <CustomPagination
        totalItems={filteredData.length}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
        pageSizeOptions={[30, 50, 100, 500]}
        startIndex={startIndex}
        endIndex={endIndex}
      />
    </div>
  );
}
